import { create } from "@/store";

type ActivityLogState = {
  loading: boolean;
  events: ParseCameraEvent[];
  selectedEventId?: string | null;
  /** Used for the Timeline Player */
  playerEvent?: ParseCameraEvent | null;
  reachedEnd: boolean;
  error: boolean;
};

type ActivityLogStore = ActivityLogState & {
  setLoading(loading: boolean): void;
  setEvents(events: ActivityLogState["events"]): void;
  addEvents(newEvents: ActivityLogState["events"]): void;
  removeEvent(uniqueId: string): number;
  setSelectedEventId(selectedEventId: string | null): void;
  setPlayerEvent(playerEvent: ParseCameraEvent | null): void;
  setReachedEnd(state: boolean): void;
  setError(state: boolean): void;
  resetState(): void;
};

const initialState: ActivityLogState = {
  loading: true,
  events: [],
  playerEvent: null,
  selectedEventId: null,
  reachedEnd: false,
  error: false
};

const useActivityLog = create<ActivityLogStore>()((set, get) => ({
  ...initialState,
  addEvents(newEvents) {
    set(({ events }) => ({ events: [...events, ...newEvents] }));
  },
  setEvents(events) {
    set({ events });
  },
  removeEvent(uniqueId) {
    let selectedEventId = get().selectedEventId;
    const filteredEvents = get().events.filter((e) => e.uniqueId !== uniqueId);
    if (uniqueId === selectedEventId) selectedEventId = filteredEvents[0]?.uniqueId;
    set({ events: filteredEvents, selectedEventId });
    return filteredEvents.length;
  },
  setLoading(loading) {
    set({ loading });
  },
  setSelectedEventId(selectedEventId) {
    set({ selectedEventId });
  },
  setPlayerEvent(playerEvent) {
    set({ playerEvent });
  },
  setReachedEnd(state: boolean) {
    set({ reachedEnd: state });
  },
  setError(state: boolean) {
    set({ error: state });
  },
  resetState() {
    set(initialState);
  }
}));

const activityLogStore = useActivityLog.getState;

export { useActivityLog, activityLogStore };
